import { create } from "zustand";

interface GeolocationState {
  latitude: number | null;
  longitude: number | null;
  setGeolocation: (latitude: number, longitude: number) => void;
  clearGeolocation: () => void;
}

export const useGeolocationStore = create<GeolocationState>((set) => ({
  latitude: null,
  longitude: null,
  setGeolocation: (latitude, longitude) => set({ latitude, longitude }),
  clearGeolocation: () => set({ latitude: null, longitude: null }),
}));

